"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const noop_1 = __importDefault(require("lodash/noop"));
const prop_types_1 = __importDefault(require("prop-types"));
const utils_1 = require("../../utils/utils");
require("../../styles/components/a-link.less");
const ALink = ({ link, href, params, className, children, doBefore, disabled, openInNewTab, generateRoute, transitionRoute, }) => {
    const handleClick = (0, react_1.useCallback)((e) => {
        if (disabled) {
            e.preventDefault();
            return;
        }
        if (utils_1.isSFDC && transitionRoute) {
            transitionRoute(link, ...params);
        }
        doBefore();
    }, [disabled, doBefore, link, params, transitionRoute]);
    return (react_1.default.createElement("span", { className: (0, classnames_1.default)(className, { 'a-link': utils_1.isSFDC }), onClick: handleClick }, utils_1.isSFDC
        ? children
        : (react_1.default.createElement("a", { href: href || generateRoute(link, ...params), className: className, target: openInNewTab ? '_blank' : undefined, rel: "noopener noreferrer" }, children))));
};
ALink.defaultProps = {
    link: '',
    href: '',
    params: [],
    className: '',
    doBefore: noop_1.default,
    generateRoute: () => '',
    disabled: false,
    openInNewTab: false,
};
ALink.propTypes = {
    link: prop_types_1.default.string,
    href: prop_types_1.default.string,
    params: prop_types_1.default.array,
    className: prop_types_1.default.string,
    doBefore: prop_types_1.default.func,
    generateRoute: prop_types_1.default.func,
    disabled: prop_types_1.default.bool,
    openInNewTab: prop_types_1.default.bool,
};
exports.default = ALink;
//# sourceMappingURL=a-link.js.map